import Sidebar from './Sidebar';
export default Sidebar;



// WEBPACK FOOTER //
// ./src/js/Sidebars/index.js